import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import api, { LOGOS } from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); setMsg("Missing token"); return; }
    api.get(`/auth/verify-email?token=${token}`)
      .then(({ data }) => {
        if (data.needs_activation) { navigate(`/activate?token=${encodeURIComponent(token)}`, { replace: true }); return; }
        setState("ok"); setMsg(data.message);
      })
      .catch((e) => { setState("error"); setMsg(e.response?.data?.detail || "Verification failed"); });
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] p-6">
      <div className="w-full max-w-md bg-white border rounded-xl p-8 text-center">
        <img src={LOGOS.campus} alt="Campus Connections" className="h-14 w-auto mx-auto mb-6 object-contain" />
        {state === "loading" && <Loader2 className="w-10 h-10 mx-auto text-cc-blue animate-spin" />}
        {state === "ok" && <CheckCircle2 className="w-12 h-12 mx-auto text-cc-green" />}
        {state === "error" && <XCircle className="w-12 h-12 mx-auto text-red-500" />}
        <p className="mt-4 text-zinc-700" data-testid="verify-message">{msg || "Verifying your email..."}</p>
        <Link to="/login" className="inline-block mt-6 px-5 py-2 rounded-md bg-cc-blue text-white text-sm font-medium">Go to login</Link>
      </div>
    </div>
  );
}
